import { SocialItem, SocialProps } from '../../types/types';

const Social: React.FC<SocialProps> = ({ className, social }) => {
  return (
    <ul className={className}>
      {social.map((item: SocialItem) => (
        <li key={item.id} className={`${className}__item`}>
          <a
            href={`${item.href}${item.name}${item.subject}`}
            target='_blank'
            rel='noopener noreferrer'
            className={`${className}__link`}
          >
            {item.svg ? (
              item.svg
            ) : (
              <span className={`${className}__text text-medium`}>
                {item.title}
              </span>
            )}
          </a>
          {item.insert && (
            <span className={`${className}__text text-micro`}>
              {item.title}
            </span>
          )}
        </li>
      ))}
    </ul>
  );
};

export default Social;
